// app/providers.tsx
'use client';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useState } from 'react';

export default function ReactQueryProviders({
  children,
}: {
  children: React.ReactNode;
}) {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 5 * 60 * 1000, // 5 minutes - data stays fresh longer
            gcTime: 10 * 60 * 1000, // 10 minutes - keep cached data for 10 minutes (previously cacheTime)
            refetchOnWindowFocus: false, // Don't refetch on window focus for better UX
            refetchOnMount: false, // Don't refetch on mount if data exists in cache
            retry: 1, // Retry failed requests once
            // Use placeholderData to keep previous data visible while refetching
            placeholderData: (previousData: unknown) => previousData,
          },
        },
      }),
  );

  return (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  );
}
